var map = {
	"./Dashboard_and_statistics.svg": "kNUO",
	"./Manage_solutions.svg": "psO3",
	"./New_registration.svg": "9XGT",
	"./SME.svg": "ocYT",
	"./SME_logo.svg": "YuUM",
	"./Solution_certification.svg": "wjcC",
	"./additional-functionalities.svg": "btP5",
	"./address_logo.svg": "GWq8",
	"./arrowDown.svg": "WYMj",
	"./arrowDownDarkBlue.svg": "UFhN",
	"./calendar.svg": "BZso",
	"./contact_us.svg": "fluA",
	"./contact_us_logo.svg": "ID2w",
	"./continue.svg": "N+6s",
	"./dashboard_logo.svg": "zU4P",
	"./delete.svg": "mMQ0",
	"./done.svg": "rQzq",
	"./download.svg": "Z3LA",
	"./downloadInvoice.svg": "V1Cd",
	"./edit.svg": "XRFS",
	"./email_logo.svg": "2RhJ",
	"./font/icn.svg": "1f/L",
	"./grayCircle.svg": "3sbd",
	"./grayLine.svg": "Zp0C",
	"./greenBorderCircle.svg": "IvrB",
	"./greenLine.svg": "X7yY",
	"./green_check.svg": "sAas",
	"./info.svg": "bf//",
	"./left-arrow.svg": "4Q4Z",
	"./leftArrow.svg": "TBdu",
	"./location.svg": "Ii6O",
	"./logo.svg": "X7t1",
	"./logout.svg": "kiTj",
	"./logoutDarkBlue.svg": "D5PC",
	"./logout_logo.svg": "jOAu",
	"./logout_logo_sidebar.svg": "R9xF",
	"./mail.svg": "cuiR",
	"./manage_solutions_logo.svg": "IhOZ",
	"./new_reg_logo.svg": "n6c0",
	"./no_data.svg": "aQ/c",
	"./notSubmitted.svg": "FUql",
	"./not_found.svg": "O+Y4",
	"./rejectedInvoice.svg": "5rtI",
	"./resetForm.svg": "UzRi",
	"./right-arrow.svg": "reng",
	"./saveForm.svg": "NyJ5",
	"./searchIcon.svg": "iUwR",
	"./serviceProvider.svg": "y47e",
	"./simplified.svg": "6fCx",
	"./solutionReg.svg": "hjYR",
	"./solution_logo.svg": "LlQq",
	"./solution_reg_logo.svg": "s9KV",
	"./standard.svg": "mVQd",
	"./svgs/alert-circle-filled.svg": "+Ir0",
	"./svgs/check.svg": "KxKY",
	"./svgs/cross-box.svg": "P5Bx",
	"./svgs/file-download.svg": "38KM",
	"./svgs/floppy.svg": "fKN9",
	"./svgs/info-circle-filled.svg": "a1TZ",
	"./svgs/loading.svg": "zP0s",
	"./svgs/plus-circle.svg": "UY8t",
	"./svgs/social-fb.svg": "D0WL",
	"./svgs/social-linkedin.svg": "Qnyo",
	"./svgs/social-x.svg": "QSIN",
	"./svgs/social-youtube.svg": "Mv5m",
	"./svgs/trash.svg": "tyty",
	"./tax_return.svg": "3WU1",
	"./view.svg": "jEtX",
	"./viewInvoice.svg": "gn/k",
	"./viewInvoices.svg": "Iebk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eepk";